import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";
import Home from "./Home";
import Header from "./Header";
import Footer from "./Footer";
import SearchPage from "./SearchPage";
function App() {
	return (
		<div className="app">
			<Router>
				<Header />
				{/* switch between different routes  */}
				<Switch>
					<Route path="/search">
						<SearchPage />
					</Route>
					<Route path="/">
						<Home />
					</Route>
				</Switch>

				<Footer />
			</Router>
		</div>
	);
}

export default App;
